import request from '@/router/axios';
//  借证书或者钥匙提交
export const cerfiticateRecord = (data) => {
  return request({
    url: `/api/blade-borrowkeycerfiticate/borrowkeycerfiticate/cerfiticateRecord`,
    method: "post",
    data: data
  });
};
